import { JsonRpcResult } from 'node-jsonrpc-client'

type s = string
type n = number

interface AddDataParams<T> {
  method: Methods
  args:
    | [s, T]
    | [s, s, T]
    | [s, s, s, T]
    | [s, null, T]
    | [s, s, n, T]
    | [s, s, s, n, T]
}

type GetDataParams<T> = [s, s, T]

export interface JsonRpcCallArgs<T> {
  method: Methods
  params:
    | Record<string, unknown>
    | AddDataParams<T>[][]
    | GetDataParams<T>
    | [string, ...unknown[]]
}

export type JsonRpcCall = <T>({
  method,
  params,
}: JsonRpcCallArgs<T>) => Promise<JsonRpcResult<T>>

export interface OtysSuccessResponseResult<T> {
  status: OtysResponseStatus
  data: T
}

export interface OtysErrorResponseResult {
  status: OtysResponseStatus
  message: string
}

export interface OtysSuccessResponse<T> {
  result: OtysSuccessResponseResult<T>[]
}

export interface OtysErrorResponse {
  result: OtysErrorResponseResult[]
}

export enum OtysResponseStatus {
  ERROR = 'error',
  SUCCESS = 'success',
}

export enum Methods {
  EXECUTE_CALL = 'Otys.Services.MultiService.execute',
  // ? Auth service
  LOGIN_BY_UID = 'loginByUid',
  LOGOUT = 'logout',
  CHECK_LOGIN = 'check',
  // ? Candidate service
  CHECK_EMAIL = 'Otys.Services.CandidateService.checkEmailAddresses',
  ADD_CANDIDATE = 'Otys.Services.CandidateService.add',
  UPDATE_CANDIDATE = 'Otys.Services.CandidateService.update',
  UPDATE_CANDIDATE_EXTENDED = 'Otys.Services.CandidateService.updateEx',
  GET_CANDIDATE = 'Otys.Services.CandidateService.getDetail',
  GET_CANDIDATE_STATUS = 'Otys.Services.CandidateService.getStatusListWithRanks',
  GET_CANDIDATE_LANGUAGE = 'Otys.Services.CandidateService.getLanguage',
  MATCH_CRITERIA_CANDIDATE = 'Otys.Services.CandidateService.getSearchFacilityInfo',
  GET_CANDIDATE_AVAILABILITY = 'Otys.Services.CandidateService.getAvailabilityByUid',
  GET_CANDIDATE_LIST = 'Otys.Services.CandidateService.getList',
  UPDATE_CANDIDATE_AVAILABILITY = 'Otys.Services.CandidateService.setAvailabilityByUid',
  CANDIDATE_CHANGES_ACTONOMY = 'Otys.Services.CandidateService.commitChangesToActonomy',
  GET_EXTRA_INFO_SETTING = 'Otys.Services.CandidateService.getExtraInfoSettings',
  // ? Application service
  CREATE_APPLICATION = 'Otys.Services.ProcedureService.add',
  UPATE_APPLICATION = 'Otys.Services.ProcedureService.updateEx',
  UPDATE_PROCEDURE_STATUS = 'Otys.Services.ProcedureService.updateDetailWithWorkflow',
  // ? Vacancies service
  GET_VACANCY = 'Otys.Services.VacancyService.getDetail',
  GET_VACANCIES_LIST = 'Otys.Services.VacancyService.getListEx',
  GET_VACANCY_IMAGE = 'Otys.Services.VacancyService.getImageWidthAndHeightForClient',
  // ? Custom Actions service
  MATCH_CRITERIA_SERVICE = 'Otys.Services.MatchCriteriaService.getList',
  MATCH_CRITERIA_PARTNER = 'Otys.Services.PartnerCustomActionService.getCustomActions',
  // ? Dossier & Documents services
  ADD_FILE = 'Otys.Services.AttachedDocumentsService.add',
  GET_ATTACHED_FILE = 'Otys.Services.AttachedDocumentsService.getList',
  GET_FILE_LIST = 'Otys.Services.DossierService.getList',
  DELETE_FILE = 'Otys.Services.AttachedDocumentsService.delete',
  LIST_FILE_TYPES = 'Otys.Services.NoticeService.getTypesForEntity',
  // ? Relations service
  GET_RELATION = 'Otys.Services.RelationService.getDetail',
  GET_CRM_CRITERIA = 'Otys.Services.CrmCriteriaCategoryService.getListEx',
  // ? Email service
  SEND_EMAIL = 'Otys.Services.EmailService.send',
}
